/* Services */
import clioService from '~/src/services/api/clioService';

function clio() {
  const searchMatter = async (orgFprint: string, params: any) => {
    return clioService.searchMatter(orgFprint, params);
  };

  const authenticate = async (orgFprint: string, code: string) => {
    if (orgFprint === undefined) {
      console.error('authenticate called with undefined orgFprint');
    }
    return clioService.authenticate(orgFprint, code);
  };

  const sync = async (orgFprint: string) => {
    return clioService.sync(orgFprint);
  };

  const getWorkTemplateMigrationOverview = async (
    orgFprint: string,
    recheck = false,
    copyJobId: number | null = null,
  ) => {
    return clioService.getWorkTemplateMigrationOverview(
      orgFprint,
      recheck,
      copyJobId,
    );
  };

  const startWorkTemplateMigration = async (
    orgFprint: string,
    templateIds: number[],
    notifyByEmail = false,
  ) => {
    return clioService.startWorkTemplateMigration(
      orgFprint,
      templateIds,
      notifyByEmail,
    );
  };

  const cancelWorkTemplateMigration = async (
    orgFprint: string,
    templateIds?: number[],
  ) => {
    return clioService.cancelWorkTemplateMigration(orgFprint, templateIds);
  };

  const matterSync = (
    orgFprint: string,
    matterId: string,
    location?: string,
  ) => {
    return clioService.matterSync(orgFprint, matterId, location);
  };

  const matterSyncV2 = (
    orgFprint: string,
    matterId: string,
    location?: string,
  ) => {
    return clioService.matterSyncV2(orgFprint, matterId, location);
  };

  const bulkImport = async (orgFprint: string) => {
    return clioService.bulkImport(orgFprint);
  };

  const getClioIntegrationData = async (orgFprint: string) => {
    return clioService.clioIntegrationData(orgFprint);
  };

  const deauthenticate = async (orgFprint: string) => {
    return clioService.deauthenticate(orgFprint);
  };

  return {
    searchMatter,
    sync,
    getWorkTemplateMigrationOverview,
    startWorkTemplateMigration,
    cancelWorkTemplateMigration,
    matterSync,
    matterSyncV2,
    bulkImport,
    authenticate,
    deauthenticate,
    getClioIntegrationData,
  };
}

export default clio();
